import React from "react";
import { Box, Tabs, Tab } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useTabVisibility } from "./TabVisibility";
import Image from "../../components/Image";

const HeaderTabs = () => {
  const { isVisible } = useTabVisibility();
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (event, newValue) => {
    navigate(newValue);
  };

  const handleChangeLogo = () => {
    navigate("/myStore");
  };

  // ✅ Tab data as an array
  const tabItems = [
    { label: "My Store", value: "/myStore" },
    { label: "Subscriptions & Services", value: "/subscription" },
    { label: "Payment Method", value: "/payments" },
    { label: "Activity", value: "/activity" },
  ];

  return (
    <Box sx={{ display: "flex", alignItems: "center", maxWidth: "100%" }}>
      {isVisible && (
        <Box
          sx={{
            borderColor: "divider",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            whiteSpace: "nowrap",
          }}
        >
          <Tabs
            value={location.pathname === "/" ? "/myStore" : location.pathname}
            onChange={handleChange}
            aria-label="Header Navigation Tabs"
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              display: "flex",
              "& .MuiTabs-flexContainer": {
                flexWrap: "nowrap",
                padding: 0,
              },
            }}
            TabIndicatorProps={{
              sx: {
                display: "none",
              },
            }}
          >
            {/* ✅ Logo + Brand Name */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "10px",
                marginLeft: "5px",
                cursor: "pointer",
              }}
            >
              <Image
                cdn="store/logo/Clikkle Store Icon.png"
                sx={{ height: "40px" }}
              />
              <span>
                <span
                  style={{
                    fontSize: "22px",
                    fontWeight: 500,
                    paddingRight: "6px",
                    paddingLeft: "8px",
                    color: "#A5A5A5",
                  }}
                >
                  Clikkle
                </span>
                <span
                  style={{
                    fontSize: "22px",
                    fontWeight: "normal",
                    color: "GrayText",
                  }}
                >
                  Store
                </span>
              </span>
            </Box>

            {tabItems.map((tab) => (
              <Tab
                key={tab.value}
                label={
                  <label
                    style={{
                      position: "relative",
                      display: "inline-block",
                      cursor: "pointer",
                    }}
                  >
                    {tab.label}
                    {location.pathname === tab.value && (
                      <span
                        style={{
                          position: "absolute",
                          left: 0,
                          bottom: -4,
                          height: 2,
                          width: "100%",
                          backgroundColor: "#1976d2",
                          borderRadius: 1,
                        }}
                      />
                    )}
                  </label>
                }
                value={tab.value}
                sx={{ mt: "0px", minWidth: "unset", textTransform: "none" }}
              />
            ))}
          </Tabs>
        </Box>
      )}
    </Box>
  );
};

export default HeaderTabs;
